import { useId, useEffect } from 'react';

function useA11y(props) {
  const id = `dropdown-${useId()}`;

  // keep a consistent aria-label applied to the toggler button
  useEffect(() => {
    const toggler = props.triggerRef.current;
    if (!toggler) {
      return;
    }
    toggler.setAttribute("aria-owns", id);
  }, [id, props.triggerRef]);
  return id;
}

export { useA11y };
//# sourceMappingURL=hook.a11y.js.map
